<!-- INC 65 (2ª vuelta): SIN `overflow-hidden` aquí. Los menús de la barra (variables,
     color, enlace) son `absolute` dentro de esta tarjeta, así que un recorte en el
     contenedor los cortaba por abajo: el de variables mostraba ~16 de 23 y la última
     fila se veía partida. Las esquinas redondeadas siguen bien porque ni la barra ni
     el área editable pintan fondo propio. -->
<div class="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">

  <!-- INC 82: selector de vista. El editor era solo WYSIWYG, así que quien pegaba una
       estructura HTML la veía convertida en texto, se guardaba escapada y el destinatario
       recibía las etiquetas a la vista. -->
  <div class="flex items-center gap-1 border-b border-gray-100 dark:border-gray-800 px-2 py-1.5">
    <button type="button" (click)="setMode('design')"
            [class]="mode === 'design'
              ? 'h-8 px-3 rounded-md text-xs font-semibold bg-brand-50 text-brand-600 dark:bg-brand-500/15 dark:text-brand-400'
              : 'h-8 px-3 rounded-md text-xs font-medium text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800'">
      Diseño
    </button>
    <button type="button" (click)="setMode('html')"
            [class]="mode === 'html'
              ? 'h-8 px-3 rounded-md text-xs font-semibold bg-brand-50 text-brand-600 dark:bg-brand-500/15 dark:text-brand-400'
              : 'h-8 px-3 rounded-md text-xs font-medium text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800'">
      HTML
    </button>
    <button type="button" (click)="setMode('preview')"
            [class]="mode === 'preview'
              ? 'h-8 px-3 rounded-md text-xs font-semibold bg-brand-50 text-brand-600 dark:bg-brand-500/15 dark:text-brand-400'
              : 'h-8 px-3 rounded-md text-xs font-medium text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800'">
      Vista previa
    </button>
  </div>

  <!-- Barra de herramientas -->
  <!-- `relative`: los menús de la barra se anclan a ELLA, no al botón (ver el menú de
       variables más abajo). -->
  <div class="rte-toolbar relative flex items-center gap-0.5 border-b border-gray-100 dark:border-gray-800 px-2 py-1.5 flex-wrap"
       [class.hidden]="mode !== 'design'">
    <!-- INC 65: estilo de bloque (párrafo / títulos / cita) -->
    <select [disabled]="disabled" (change)="onBlockFormatChange($event)" title="Estilo de texto"
            class="h-8 rounded-md border border-gray-200 dark:border-gray-700 bg-transparent px-2 text-xs text-gray-600 dark:text-gray-300 disabled:opacity-40">
      <option value="">Estilo</option>
      @for (bf of blockFormats; track bf.value) {
        <option [value]="bf.value">{{ bf.label }}</option>
      }
    </select>

    <span class="mx-1 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>

    <button type="button" [disabled]="disabled" (click)="exec('bold')" title="Negrita"
            class="h-8 w-8 inline-flex items-center justify-center rounded-md text-sm font-bold text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
      B
    </button>
    <button type="button" [disabled]="disabled" (click)="exec('italic')" title="Cursiva"
            class="h-8 w-8 inline-flex items-center justify-center rounded-md text-sm italic text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
      I
    </button>
    <button type="button" [disabled]="disabled" (click)="exec('underline')" title="Subrayado"
            class="h-8 w-8 inline-flex items-center justify-center rounded-md text-sm underline text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
      U
    </button>

    <!-- INC 65: color de texto -->
    <div class="relative">
      <button type="button" [disabled]="disabled" (click)="toggleColorMenu()" title="Color del texto"
              class="h-8 w-8 inline-flex flex-col items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
        <span class="text-[11px] font-semibold leading-none">A</span>
        <span class="mt-0.5 block h-1 w-4 rounded-sm bg-gradient-to-r from-brand-500 via-error-500 to-success-500"></span>
      </button>
      @if (colorMenuOpen) {
        <div class="absolute z-20 mt-1 w-40 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-lg p-2">
          <div class="flex flex-wrap gap-1.5">
            @for (c of textColors; track c.value) {
              <button type="button" [title]="c.label" (click)="applyTextColor(c.value)"
                      class="h-6 w-6 rounded-full border border-gray-200 dark:border-gray-700"
                      [style.background]="c.value"></button>
            }
          </div>
        </div>
      }
    </div>

    <button type="button" [disabled]="disabled" (click)="clearFormat()" title="Quitar formato"
            class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 4h10M9 4l-2 16M15 4l-1 8M14 18l6-6M14 12l6 6"/>
      </svg>
    </button>

    <span class="mx-1 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>

    <!-- INC 65: alineación -->
    <button type="button" [disabled]="disabled" (click)="exec('justifyLeft')" title="Alinear a la izquierda"
            class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h10M4 18h13"/>
      </svg>
    </button>
    <button type="button" [disabled]="disabled" (click)="exec('justifyCenter')" title="Centrar"
            class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M7 12h10M6 18h12"/>
      </svg>
    </button>
    <button type="button" [disabled]="disabled" (click)="exec('justifyRight')" title="Alinear a la derecha"
            class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M10 12h10M7 18h13"/>
      </svg>
    </button>

    <span class="mx-1 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>

    <button type="button" [disabled]="disabled" (click)="exec('insertUnorderedList')" title="Lista con viñetas"
            class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>
      </svg>
    </button>
    <button type="button" [disabled]="disabled" (click)="exec('insertOrderedList')" title="Lista numerada"
            class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 6h13M7 12h13M7 18h13M4 6h.5M4 11.5h.5M4 17h.5"/>
      </svg>
    </button>

    <span class="mx-1 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>

    <div class="relative">
      <button type="button" [disabled]="disabled" (click)="openLinkPopover()" title="Insertar enlace"
              class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
        </svg>
      </button>
      @if (linkPopoverOpen) {
        <div class="absolute z-20 mt-1 w-72 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-lg p-3">
          <label class="block text-[0.7rem] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1.5">URL del enlace</label>
          <input #linkInput type="text" [(ngModel)]="linkUrl" (keydown.enter)="confirmLink()" (keydown.escape)="linkPopoverOpen = false"
                 class="w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-1.5 text-sm text-gray-900 dark:text-white" />
          <div class="flex justify-end gap-2 mt-2">
            <button type="button" (click)="linkPopoverOpen = false" class="px-3 py-1 text-xs font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full">Cancelar</button>
            <button type="button" (click)="confirmLink()" class="px-3 py-1 text-xs font-medium text-white bg-brand-500 hover:bg-brand-600 rounded-full">Insertar</button>
          </div>
        </div>
      }
    </div>
    @if (uploadHandler) {
      <span class="mx-1 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>
      <input #imageInput type="file" accept="image/*" class="hidden" (change)="onImageSelected($event)" />
      <button type="button" [disabled]="disabled || imageUploading" (click)="triggerImageUpload()" title="Insertar imagen"
              class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
        @if (imageUploading) {
          <svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
        } @else {
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14M14 8h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
        }
      </button>
    }
    @if (attachmentUploadHandler) {
      <span class="mx-1 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>
      <input #attachmentInput type="file" multiple accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip" class="hidden" (change)="onAttachmentSelected($event)" />
      <button type="button" [disabled]="disabled" (click)="triggerAttachmentUpload()" title="Adjuntar archivo"
              class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-40">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.44 11.05l-9.19 9.19a5.5 5.5 0 01-7.78-7.78l9.2-9.19a3.5 3.5 0 014.95 4.95l-9.2 9.19a1.5 1.5 0 01-2.12-2.12l8.49-8.48"/>
        </svg>
      </button>
    }
    @if (variableNamespaces.length > 0) {
      <span class="mx-1 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>
      <!-- SIN `relative`: el menú se ancla a la barra (`.rte-toolbar`), no a este botón. -->
      <div>
        <button #variablesBtn type="button" [disabled]="disabled" (click)="toggleVariablesMenu()"
                title="Insertar variable en el cuerpo"
                class="h-8 px-2.5 inline-flex items-center gap-1.5 rounded-md text-xs font-semibold text-violet-600 dark:text-violet-400 hover:bg-violet-50 dark:hover:bg-violet-500/10 disabled:opacity-40">
          <span class="font-mono">{{ '{{ }}' }}</span>
          <span>Variables</span>
        </button>
        @if (variablesMenuOpen) {
          <!-- Lista vertical (antes eran chips en flex-wrap): cada variable muestra su
               etiqueta Y el tag que se inserta, sin recortes. La altura está acotada y
               el scroll vive DENTRO del menú.

               Anclado a la BARRA con `left-0 right-0` (no al botón con `right-0 w-80`):
               el editor puede vivir en un panel estrecho con scroll propio —el inspector
               del constructor de chatflows mide 320 px— y allí un menú de 320 px colgado
               del botón se salía 108 px por la izquierda; el `overflow` del panel lo
               recortaba justo por donde van las etiquetas. Así el menú nunca es más ancho
               que el propio editor. `max-w` evita que se estire de más en formularios
               anchos. El alto de la lista lo calcula `measureVariablesMenu()`. -->
          <div class="absolute left-0 right-0 z-20 max-w-[26rem] rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-lg"
               [class.top-full]="!variablesMenuDropUp" [class.mt-1]="!variablesMenuDropUp"
               [class.bottom-full]="variablesMenuDropUp" [class.mb-1]="variablesMenuDropUp">
            <div class="border-b border-gray-100 dark:border-gray-800 p-2">
              <input #variablesSearch type="text" [(ngModel)]="variableSearch"
                     (keydown.escape)="variablesMenuOpen = false"
                     placeholder="Buscar variable…"
                     class="w-full rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-2.5 py-1.5 text-xs text-gray-800 dark:text-gray-100 focus:outline-none focus:border-violet-400" />
            </div>
            <div class="overflow-y-auto p-2 space-y-3" [style.max-height]="variablesMenuListMaxHeight">
              @for (ns of filteredNamespaces; track ns.name) {
                <div>
                  @if (filteredNamespaces.length > 1 || ns.displayName) {
                    <p class="px-1 pb-1 text-[0.7rem] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
                      {{ ns.displayName }} ({{ ns.variables.length }})
                    </p>
                  }
                  @for (v of ns.variables; track v.key) {
                    <button type="button"
                            [title]="v.description || v.sample || ''"
                            (click)="insertVariable(v.key)"
                            class="w-full rounded-md px-2 py-1.5 text-left hover:bg-violet-50 dark:hover:bg-violet-500/10">
                      <span class="block text-xs font-medium text-gray-700 dark:text-gray-200">{{ v.label }}</span>
                      <span class="block font-mono text-[11px] leading-tight text-violet-600 dark:text-violet-400 break-all">{{ '{{' + v.key + '}}' }}</span>
                    </button>
                  }
                </div>
              }
              @if (visibleVariableCount === 0) {
                <p class="px-2 py-3 text-xs text-gray-500 dark:text-gray-400">No hay variables que coincidan con "{{ variableSearch }}".</p>
              }
            </div>
            <p class="border-t border-gray-100 dark:border-gray-800 px-3 py-1.5 text-[11px] text-gray-500 dark:text-gray-400">
              {{ visibleVariableCount }} de {{ totalVariableCount }} variables — se reemplazan al enviar
            </p>
          </div>
        }
      </div>
    }
  </div>

  @if (imageUploadError) {
    <p class="px-4 pt-2 text-xs text-error-500">{{ imageUploadError }}</p>
  }
  @if (attachmentUploadError) {
    <p class="px-4 pt-2 text-xs text-error-500">{{ attachmentUploadError }}</p>
  }

  <!-- Franja de adjuntos (estilo Hotmail/Outlook): viven fuera del contenteditable, así que
       nunca pueden corromper listas/formato del cuerpo. -->
  @if (attachments.length > 0) {
    <div class="flex flex-wrap gap-2 px-4 py-3 border-b border-gray-100 dark:border-gray-800">
      @for (att of attachments; track $index; let i = $index) {
        <span class="inline-flex items-center gap-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 pl-2 pr-1.5 py-1.5">
          @if (att.uploading) {
            <svg class="h-4 w-4 animate-spin text-gray-400" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
          } @else {
            <span class="flex-shrink-0 w-6 h-6 rounded flex items-center justify-center text-[9px] font-bold"
                  [style.background]="badgeFor(att.fileName).bg" [style.color]="badgeFor(att.fileName).color">
              {{ badgeFor(att.fileName).label }}
            </span>
          }
          <span class="text-xs text-gray-700 dark:text-gray-300" [title]="att.fileName">
            {{ att.uploading ? 'Subiendo ' + displayName(att.fileName) + '…' : displayName(att.fileName) }}
          </span>
          <button type="button" (click)="removeAttachment(i)" title="Quitar adjunto"
                  class="h-5 w-5 inline-flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-600 dark:hover:bg-gray-700">
            ×
          </button>
        </span>
      }
    </div>
  }

  <!-- INC 82: el cuerpo guardado trae las etiquetas como TEXTO (contenido pegado antes de que
       existiera la vista de código). Se ofrece interpretarlo, si no el correo sale con el
       marcado a la vista. -->
  @if (escapedHtmlDetected && mode === 'design' && !disabled) {
    <div class="flex flex-wrap items-center justify-between gap-2 border-b border-warning-200 bg-warning-50 px-4 py-2.5 dark:border-warning-500/30 dark:bg-warning-500/10">
      <p class="text-xs text-warning-700 dark:text-warning-400">
        Este contenido tiene código HTML escrito como texto: al enviarlo, el destinatario verá las etiquetas.
      </p>
      <button type="button" (click)="interpretAsHtml()"
              class="shrink-0 rounded-md bg-warning-500 px-3 py-1.5 text-xs font-semibold text-white hover:bg-warning-600">
        Interpretar como HTML
      </button>
    </div>
  }

  <!-- INC 82: vista de código. El textarea es la fuente de verdad mientras está abierto. -->
  <div [class.hidden]="mode !== 'html'">
    <textarea
      [(ngModel)]="htmlSource"
      (ngModelChange)="onHtmlSourceInput()"
      [disabled]="disabled"
      spellcheck="false"
      [style.min-height]="minHeight"
      class="w-full resize-y bg-transparent px-4 py-4 font-mono text-xs leading-relaxed text-gray-800 focus:outline-none dark:text-gray-100"
      style="max-height: calc(100vh - 280px);"
      placeholder="<p>Escribe aquí el HTML del correo…</p>"></textarea>
  </div>

  <!-- INC 82: vista previa renderizada, aislada en un iframe sin scripts para que ni el
       correo herede los estilos de la app ni la app ejecute nada del correo. -->
  <div [class.hidden]="mode !== 'preview'" class="px-4 py-4">
    <iframe #previewFrame sandbox title="Vista previa del correo"
            [style.min-height]="minHeight"
            class="w-full rounded-lg border border-gray-200 bg-white dark:border-gray-700"
            style="max-height: calc(100vh - 280px);"></iframe>
  </div>

  <!-- Área editable -->
  <div class="relative"
       [class.hidden]="mode !== 'design'"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave()"
       (drop)="onDrop($event)">
    @if (empty) {
      <p class="pointer-events-none absolute top-4 left-4 text-sm text-gray-400 dark:text-gray-500">{{ placeholder }}</p>
    }
    <div #editable
         (input)="onInput()"
         (blur)="onInput()"
         (click)="onEditableClick($event)"
         [style.min-height]="minHeight"
         class="rte-editable px-4 py-4 text-sm text-gray-800 dark:text-gray-100 leading-relaxed focus:outline-none overflow-y-auto"
         style="max-height: calc(100vh - 280px);">
    </div>
    @if (dragOver) {
      <div class="pointer-events-none absolute inset-1 flex items-center justify-center rounded-xl border-2 border-dashed border-brand-400 bg-brand-50/80 dark:bg-brand-500/10">
        <p class="text-sm font-medium text-brand-600 dark:text-brand-400">Suelta aquí para adjuntar</p>
      </div>
    }
  </div>
</div>
